import { render, staticRenderFns } from "./GeneralTab.vue?vue&type=template&id=379d765e&scoped=true"
import script from "./GeneralTab.ts?vue&type=script&lang=ts&external"
export * from "./GeneralTab.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "379d765e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src2316091614/src/sctd-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('379d765e')) {
      api.createRecord('379d765e', component.options)
    } else {
      api.reload('379d765e', component.options)
    }
    module.hot.accept("./GeneralTab.vue?vue&type=template&id=379d765e&scoped=true", function () {
      api.rerender('379d765e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/Modules/Cups/components/tabs/GeneralTab/GeneralTab.vue"
export default component.exports